import React from "react"

import { motion } from "framer-motion"
import { SectionWrapper } from "../hoc"
import { Tilt } from "react-tilt"
import { fadeIn } from "../utils/motion"
import { Link } from "react-router-dom"
const Companies = ({ index }) => {
  return (
    <>
      <div className="mt-20 bg-black flex flex-wrap pb-8 items-center justify-center overflow-hidden ">
        <section className="tilt-container w-full h-full  mt-10 ">
          <Tilt className="  md:w-6/12  ">
            <Link to="/studio32">
              {" "}
              <motion.div
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
                variants={fadeIn("right", "spring", index * 0.5, 0.65)}
                className="w-full justify-center flex p-[1px] rounded-[20px] pb-4  "
              >
                <div
                  options={{
                    max: 45,
                    scale: 1,
                    speed: 450,
                  }}
                  className="bg-[url('/src/assets/S32_main.jpg')] bg-gray-400 filter grayscale hover:filter-none transition-all duration-300 bg-cover rounded-[20px] py-8 px-16 w-9/12  md:h-[300px] lg:h-[420px] flex justify-evenly items-center flex-col shadow-card min-h-[200px]"
                >
                  <h3 className="text-black text-[24px] font-leading font-bold text-center uppercase">
                    Studio 32
                  </h3>
                </div>
              </motion.div>{" "}
            </Link>
            <p className="flex justify-center font-leading tracking-widest">
              Interior Design{" "}
            </p>
          </Tilt>

          <Tilt className=" md:w-6/12  ">
            <Link to="/akrutibuildcon">
              <motion.div
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
                variants={fadeIn("left", "spring", 0.5, 0.65)}
                className="w-full justify-center flex p-[1px] rounded-[20px] pb-4"
              >
                <div
                  options={{
                    max: 45,
                    scale: 1,
                    speed: 450,
                  }}
                  className="bg-[url('/src/assets/AB_main.png')] bg-gray-400 filter grayscale hover:filter-none transition-all duration-300 bg-cover rounded-[20px] py-8 px-16 w-9/12 md:h-[300px] lg:h-[420px] flex justify-evenly items-center flex-col shadow-card min-h-[200px]"
                >
                  <h3 className="text-black text-[24px] font-leading text-center uppercase font-bold">
                    Akruti Buildcon
                  </h3>
                </div>
              </motion.div>
            </Link>
            <p className="flex justify-center font-leading tracking-widest ">
              Building Design
            </p>
          </Tilt>
        </section>
      </div>
    </>
  )
}

export default SectionWrapper(Companies, "companies")
